import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {ConditionalSection, QuoteFormConditionalSection} from 'Quoting/components/shared/QuoteFormConditionalSection';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {
  AccidentalDeath,
  AccidentalDeathAndDismembermentUnits,
  AccidentalDeathCommonCarrier,
  FunctionalLoss,
} from './AccidentalDeathAndDismemberment';
import {GVA6AccidentalDismembermemt} from './GVA6AccidentalDismemberment';
import {deathandDismembermentPath} from './PropertyPaths/propertyPathACC';

export const AccidentalDeathAndDismembermentGVA6Block = () => {
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const propertyPaths = deathandDismembermentPath(selectedPlan?.planIndex ?? 0);

  const accidentalDeathAndDismembermentSections: ConditionalSection[] = [
    {
      Component: AccidentalDeath,
      key: 'accidentalDeathDetails',
      label: 'Accidental Death',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isAccidentalDeathApplied),
      onToggleVisibility: (isApplied: boolean) => {
        updateQuoteFieldValue(propertyPaths.isAccidentalDeathApplied, isApplied);
      },
    },
    {
      Component: AccidentalDeathCommonCarrier,
      key: 'accidentalDeathCommonCarrierDetails',
      label: 'Accidental Death - Common Carrier',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isAccidentalDeathCommonCarrierApplied),
      onToggleVisibility: (isApplied: boolean) => {
        updateQuoteFieldValue(propertyPaths.isAccidentalDeathCommonCarrierApplied, isApplied);
      },
    },
    {
      Component: GVA6AccidentalDismembermemt,
      key: 'gva6accidentalDismembermentDetails',
      label: 'Accidental Dismembermemt',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isAccidentalDismembermentApplied),
      onToggleVisibility: (isApplied: boolean) => {
        updateQuoteFieldValue(propertyPaths.isAccidentalDismembermentApplied, isApplied);
      },
    },
    {
      Component: FunctionalLoss,
      key: 'functionalLossDetails',
      label: 'Functional Loss',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isFunctionalLossApplied),
      onToggleVisibility: (isApplied: boolean) => {
        updateQuoteFieldValue(propertyPaths.isFunctionalLossApplied, isApplied);
      },
    },
  ];

  return (
    <FormWrapper title="Accidental Death and Dismemberment" collapsible withSeparator>
      <Grid container direction="column">
        <AccidentalDeathAndDismembermentUnits />
        <QuoteFormConditionalSection sections={accidentalDeathAndDismembermentSections} />
      </Grid>
    </FormWrapper>
  );
};
